import { deleteApiWithData, getApi, postApi, putApi } from 'apis';

export const getAllBranchCode = async (params: any) => {
	return await getApi('/branchCode', params);
};

export const createBranchCode = async (data: any) => {
	return await postApi('/branchCode', data);
};

export const updateBranchCode = async (data: any) => {
	return await putApi('/branchCode', data);
};

export const deleteBranchCode = async (data: any) => {
	return await deleteApiWithData('/branchCode', data);
};

export const getAccessibleBranchForUser = async () => {
	return await getApi('/branchCode/options');
};

export const getSupervisorsBranches = async (supervisorId:string) => {
	return await getApi(`/branchCode/supervisor/${supervisorId}`);
};

